import { render, staticRenderFns } from "./CMAccountsList.vue?vue&type=template&id=5b15dff4&"
import script from "./CMAccountsList.vue?vue&type=script&lang=js&"
export * from "./CMAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./CMAccountsList.vue?vue&type=style&index=0&id=5b15dff4&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b15dff4')) {
      api.createRecord('5b15dff4', component.options)
    } else {
      api.reload('5b15dff4', component.options)
    }
    module.hot.accept("./CMAccountsList.vue?vue&type=template&id=5b15dff4&", function () {
      api.rerender('5b15dff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMMainPage/CMAccountsList.vue"
export default component.exports